/**
 * @fileoverview
 * Toast Component - Displays toast notifications in top right corner
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, OnInit, OnDestroy, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '@core/services';
import { NotificationType, NotificationPosition } from '@core/state/models';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent implements OnInit, OnDestroy {
  private notificationService = inject(NotificationService);

  // Get notifications filtered by position (top-right)
  notifications = computed(() => 
    this.notificationService.notifications().filter(
      n => n.position === NotificationPosition.TOP_RIGHT
    )
  );

  /**
   * Get icon class based on notification type
   */
  getIconClass(type: NotificationType): string {
    const iconMap: Record<NotificationType, string> = {
      [NotificationType.SUCCESS]: 'check-circle',
      [NotificationType.ERROR]: 'x-circle',
      [NotificationType.WARNING]: 'alert-triangle',
      [NotificationType.INFO]: 'info'
    };
    return iconMap[type] || 'info';
  }

  /**
   * Get toast class based on notification type
   */
  getToastClass(type: NotificationType): string {
    const classMap: Record<NotificationType, string> = {
      [NotificationType.SUCCESS]: 'toast-success',
      [NotificationType.ERROR]: 'toast-error',
      [NotificationType.WARNING]: 'toast-warning',
      [NotificationType.INFO]: 'toast-info'
    };
    return classMap[type] || 'toast-info';
  }

  /**
   * Remove notification
   */
  remove(id: string): void {
    this.notificationService.remove(id);
  }

  ngOnInit(): void {
    // Component initialization
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }
}
